module.exports = __webpack_public_path__ + "static/schekachihin-829dcae21f8842790539f3a68fb2168f.jpg";